import { Component, OnInit, Input } from '@angular/core';
import { DieService } from '../../../../phf.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { PartDetailService } from '../part-detail.service';
import { FilterableService } from '../../../../../mesc/filterable-service';
import { PartListService } from '../../part-list.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'die-detail-tab',
  templateUrl: './die-detail-tab.component.html',
  styleUrls: ['../part-detail.component.scss']
})
export class DieDetailTabComponent implements OnInit {
  part: any;
  editForm: FormGroup;
  isEditing: boolean;
  isLoading = false;
  subscription: Subscription;
  dieSourceService: FilterableService = new FilterableService();
  dieFamilyService: FilterableService = new FilterableService();
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.part = dataItem;
    }
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly partListService: PartListService,
    private readonly dieService: DieService,
    public readonly messageService: PartDetailService,

  ) {
    this.subscription = this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.isEditing = message.editing;
      });
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group(DieEditForm);
    this.editForm.get('IsActive').setValue(true);
    this.messageService.dieDataObject = this.editForm;
    this.dieSourceService = this.partListService.lookupData.DieSourceViewDto;
    this.dieFamilyService = this.partListService.lookupData.DieFamilyViewDto;
    this.refreshInfo();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  onKeyUp = (e) => {
    if (isNaN(e.target.valueAsNumber)) {
      try {
        e.target.value = parseInt(e.target.value);
      } catch (e) {
        e.target.value = '';
      }
    }
  }

  refreshInfo() {
    if (this.part && this.part.Id) {
      this.dieService.read('/part/' + this.part.Id)
        .then(dieResult => {
          if (dieResult) {
            this.editForm.reset(dieResult);
            if (this.editForm.get('DieFamilyId').value) { this.handleDieFamilyChange(this.editForm.get('DieFamilyId').value) }
            if (this.editForm.get('DieSourceId').value) { this.handleDieSourceChange(this.editForm.get('DieSourceId').value) }
          }
          this.isLoading = false;
        })
    }
    else { this.isLoading = false; }
  }

  handleDieSourceChange = (dataItem) => {
    const dieSource = this.dieSourceService.value.find(x => x.Id === dataItem);
    this.editForm.get('SourceDieName').setValue(dieSource ? dieSource.Name : '');
  }

  handleDieFamilyChange = (dataItem) => {
    const dieFamily = this.dieFamilyService.value.find(x => x.Id === dataItem);
    this.editForm.get('DieFamilyName').setValue(dieFamily ? dieFamily.Description : '');
  }

}

const DieEditForm = {
  Id: [],
  PartsPerStroke: [],
  ActualSPH: [],
  ActualSPM: [],
  ReferencePartNumber: [],
  ReferenceCode: [],
  ReferenceProgram: [],
  ReferenceSPM: [],
  DieAndSystemSPMRestriction: [],
  ToolingRestrictionNote: [],
  ToolingReferencePlant: [],
  ToolingReferencePress: [],
  SPMDeviation: [],
  GBOP: [],
  GBOM: [],
  GBOPNote: [],
  PartId: [],
  DieFamilyId: [],
  DieSourceId: [],
  SourceDieName: [],
  DieFamilyName: [],
  IsActive: [],
  ReportDate: []

}
